import { useMemo } from 'react'
import Holidays from 'date-holidays'

export type CountryCode = 'US' | 'CA'

/**
 * Returns a Map of ISO date string (YYYY-MM-DD) → holiday name
 * for all public holidays in the given year and country.
 */
export function useHolidays(
  year: number,
  country: CountryCode,
): Map<string, string> {
  return useMemo(() => {
    const hd = new Holidays(country, { languages: ['en'], types: ['public'] })
    const yearHolidays = hd.getHolidays(year)
    const map = new Map<string, string>()
    for (const h of yearHolidays) {
      if (h.type === 'public') {
        // h.date is "YYYY-MM-DD HH:MM:SS" — take just the date part
        const dateStr = h.date.slice(0, 10)
        map.set(dateStr, h.name)
      }
    }

    return map
  }, [year, country])
}
